import {Box, HStack, Show, Space} from 'platform/foundation';

import i18n from '@dms/i18n';

import {useCountByQueryId, useDetailPagination} from 'features/eag-grid';

import {useEntityNavigation} from '../../../hooks/useEntityNavigation';
import {NavigationButton} from './NavigationButton';

export function EntityHeaderNavigation() {
  const {
    handleBreadcrumb,
    handleNavigate,
    isBreadcrumbVisible,
    isRowControlDetailVisible,
    breadcrumbProps,
  } = useEntityNavigation();
  const {rowIndex, isInvalid, onPageChange, isLoading} = useDetailPagination(
    handleNavigate,
    breadcrumbProps?.rowControlFetchStrategy
  );
  const {count, hasSourceParams} = useCountByQueryId();

  const handlePrevPage = () => {
    if (rowIndex === 1) {
      return;
    }

    onPageChange(rowIndex - 1);
  };

  const handleNextPage = () => {
    if (rowIndex === count) {
      return;
    }

    onPageChange(rowIndex + 1);
  };

  const showNavigation = isRowControlDetailVisible && hasSourceParams && !isInvalid;

  return (
    <Box position="absolute" top={0} left={0} padding={3} width="100%" zIndex="PAGE_NAVIGATION">
      <HStack justify="space-between" width="100%">
        <Show when={isBreadcrumbVisible}>
          <NavigationButton
            aria-label={i18n.t('general.actions.back')}
            icon="navigation/arrow_back"
            onClick={handleBreadcrumb}
          />
        </Show>
        <Space fillAvailable />

        <Show when={showNavigation}>
          <HStack spacing={2}>
            <NavigationButton
              aria-label={i18n.t('general.actions.previous')}
              isDisabled={isLoading || rowIndex === 1}
              icon="navigation/arrow_back_ios"
              onClick={handlePrevPage}
            />

            <NavigationButton
              aria-label={i18n.t('general.actions.next')}
              isDisabled={isLoading || rowIndex === count}
              icon="navigation/arrow_forward_ios"
              onClick={handleNextPage}
            />
          </HStack>
        </Show>
      </HStack>
    </Box>
  );
}
